const ApiUrl = process.env.NEXT_PUBLIC_API_URL;

const UrlParamsReplace = (url, params = {}) => {
  let urlWithPrefix = `${ApiUrl}${url}`;
  if (params) {
    Object.keys(params).forEach(
      (key) => (urlWithPrefix = urlWithPrefix.replace(`:${key}`, params[key]))
    );
  }
  return urlWithPrefix;
};

// Users
// Website onboarding
export const TRIGGER_WEBSITE_ONBOARDING = UrlParamsReplace('/website/onboard');
export const COMPLETE_WEBSITE_ONBOARDING = UrlParamsReplace('/website/onboard/complete');
export const TRIGGER_SEED_PRODUCTS = UrlParamsReplace('/website/seed-products');
export const GET_SEED_PRODUCTS_STATUS = UrlParamsReplace('/website/seed-products/status');

export const CREATE_USER = UrlParamsReplace('/user/create');
export const CREATE_VENDOR_ONBOARDING_DATA =
  UrlParamsReplace('/vendor/onboarding');

export const AUTHENTICATE_USER = (email) =>
  UrlParamsReplace('/user-authentication/:email', { email });
export const SIGNUP_USER_BY_EMAIL = UrlParamsReplace('/user/signUp');
export const SIGNIN_USER_BY_EMAIL = UrlParamsReplace('/user/signIn');
export const USER_ONBOARDING_API = UrlParamsReplace('/onboarding');
export const TOGGLE_FREE_ACCESS_BY_ADMIN = UrlParamsReplace(
  '/toggle-free-access-by-admin'
);
export const GET_USER_ONBOARDING_API = (userId) =>
  UrlParamsReplace('/onboarding?userId=:userId', { userId });
export const GET_USER_DETAILS = (userId) =>
  UrlParamsReplace('/user?userId=:userId', { userId });
export const GET_BUSINESS_DETAILS = (businessId) =>
  UrlParamsReplace('/business?businessId=:businessId', { businessId });
export const GET_BUSINESS_DETAILS_BY_EMAIL = (businessEmail) =>
  UrlParamsReplace('/business/email?businessEmail=:businessEmail', {
    businessEmail,
  });

export const GET_VENDOR_BUSINESS_DETAILS_BY_SUPPLIER_ID = (supplierId) =>
  UrlParamsReplace('/vendorBusiness?supplierId=:supplierId', {
    supplierId,
  });

export const CREATE_API_AUTH_TOKEN = UrlParamsReplace(
  '/user/create-api-auth-token'
);
export const VERIFY_API_AUTH_TOKEN = UrlParamsReplace('/verify-api-auth-token');

// User_Otps
export const VERIFY_OTP = UrlParamsReplace('/user_otps/verify-otp');
export const RESEND_OTP = UrlParamsReplace('/user_otps/resend-otp');

// Stripe
export const CREATE_CHECKOUT_SESSION = UrlParamsReplace(
  '/stripe/create-checkout-session'
);
export const GET_PAYMENT_METHODS = UrlParamsReplace('/stripe/payment-methods');

export const GET_INVOICES = UrlParamsReplace('/stripe/invoices');

export const GET_ACTIVE_SUBSCRIPTION = UrlParamsReplace(
  '/stripe/active-subscription'
);

export const START_EMBEDDING_ONBOARDING = UrlParamsReplace(
  '/connect/embedded-onboarding'
);

export const GET_SETTINGS_DASHBOARD = UrlParamsReplace(
  '/connect/settings-dashboard'
);
export const GET_PAYMENTS_DASHBOARD = UrlParamsReplace(
  '/connect/payments-dashboard'
);
export const GET_FINANCIAL_DASHBOARD = UrlParamsReplace(
  '/connect/financial-dashboard'
);

export const CREATE_SETUP_INTENT = UrlParamsReplace('/stripe/setup-intent');

export const GET_SETUP_INTENT_STATUS = UrlParamsReplace(
  '/stripe/setup-intent-status'
);

export const REMOVE_PAYMENT_METHOD = UrlParamsReplace(
  '/stripe/remove-payment-method'
);

export const UPDATE_DEFAULT_PAYMENT_METHOD = UrlParamsReplace(
  '/stripe/update-default-payment-method'
);

export const CANCEL_SUBSCRIPTION = UrlParamsReplace(
  '/stripe/cancel-subscription'
);
export const GET_CHECKOUT_SESSION_STATUS = UrlParamsReplace(
  '/stripe/check-active-status'
);
// Dynamic segment (featureKey) appended at the call site — see
// services/user.service.js's switchFeatureTier.
export const UPDATE_FEATURE_TIER_BASE = UrlParamsReplace('/feature-subscriptions');

// One endpoint for every merchant-initiated lifecycle change (pause, resume,
// close, reactivate) — the backend's transition map decides which are legal.
export const UPDATE_ACCOUNT_STATUS = UrlParamsReplace('/business-accounts/account-status');
export const AUTO_RENEWAL_TOGGLE = UrlParamsReplace(
  '/stripe/auto-renewal-toggle'
);
export const GET_ACTIVE_PLAN = UrlParamsReplace('/stripe/plans');

// Projects
export const CREATE_PROJECT = UrlParamsReplace('/projects');
export const GET_USER_PROJECTS = (userId, searchText, page) =>
  UrlParamsReplace(
    '/projects?userId=:userId&searchText=:searchText&page=:page',
    {
      userId,
      searchText,
      page,
    }
  );
export const GET_PROJECT_DETAILS = (projectId) =>
  UrlParamsReplace('/projects/:projectId', { projectId });
export const EDIT_PROJECT_DETAILS = (projectId) =>
  UrlParamsReplace('/projects/:projectId', { projectId });
export const DELETE_PROJECT_DETAILS = (projectId) =>
  UrlParamsReplace('/projects/:projectId', { projectId });
export const UPDATE_PROJECT_LAST_VISITED = (projectId) =>
  UrlParamsReplace('/projects/:projectId/last-visited', { projectId });

// Folders
export const GET_PROJECT_FOLDERS = (projectId, searchText, page) =>
  UrlParamsReplace(
    '/projects/:projectId/folders?searchText=:searchText&page=:page',
    {
      projectId,
      searchText,
      page,
    }
  );
export const CREATE_PROJECT_FOLDERS = UrlParamsReplace('/folders');
export const GENERATE_PRESIGNED_URL = (projectId, folderId, fileName) =>
  UrlParamsReplace('/generate-presigned-url/:projectId/:folderId/:fileName', {
    projectId,
    folderId,
    fileName,
  });

export const GET_PRESIGNED_URL = (fileUrl, type) =>
  UrlParamsReplace('/get-presigned-url?fileUrl=:fileUrl&type=:type', {
    fileUrl,
    type,
  });

export const GET_FOLDER_DETAILS = (folderId) =>
  UrlParamsReplace('/folders/:folderId', { folderId });
export const GET_USER_FOLDER = (userId) =>
  UrlParamsReplace(`/folders?userId=${userId}`);
export const UPDATE_FOLDER_LAST_VISITED = (folderId) =>
  UrlParamsReplace('/folders/:folderId/last-visited', { folderId });
export const DELETE_FOLDERS = (folderId) =>
  UrlParamsReplace('/folders/:folderId', { folderId });
export const EDIT_FOLDER_DETAILS = (folderId) =>
  UrlParamsReplace('/folders/:folderId', { folderId });

// Document Types
export const GET_FOLDER_DOC_TYPES = UrlParamsReplace('/document-types');

// Files
export const CREATE_FILES = UrlParamsReplace('/files');
export const GET_FILES_IN_FOLDER = (folderId, searchText, page) =>
  UrlParamsReplace('/files/:folderId?searchText=:searchText&page=:page', {
    folderId,
    searchText,
    page,
  });
export const GET_ALL_FILES = (userId, searchText) =>
  UrlParamsReplace('/files?searchText=:searchText&userId=:userId', {
    searchText,
    userId,
  });
export const DELETE_FILE = (fileId) =>
  UrlParamsReplace('/files/:fileId', { fileId });
export const DELETE_MULTIPLE_FILES = UrlParamsReplace('/files');
export const GET_METRICS_FOR_UPLOADED_AND_PROCESSED_FILES = (
  startDate,
  endDate,
  midDate
) =>
  UrlParamsReplace(
    '/files-metrics-for-uploaded-and-processed?startDate=:startDate&endDate=:endDate&midDate=:midDate',
    { startDate, endDate, midDate }
  );
export const GET_METRICS_FOR_PROCESSED_FILES = (startDate, endDate) =>
  UrlParamsReplace(
    '/files-metrics-for-processed?startDate=:startDate&endDate=:endDate',
    { startDate, endDate }
  );
export const CHECK_FOR_EXISTING_FILES = (folderId) =>
  UrlParamsReplace('/files/:folderId/check-exisiting-files', { folderId });
export const GET_FILE_DETAILS_BY_ID = (fileId) =>
  UrlParamsReplace('/file/:fileId', { fileId });

export const UPDATE_FILE_STATUS = (fileId, status) =>
  UrlParamsReplace('/files/:fileId/:status', { fileId, status });

export const EMAIL_PURCHASE_ORDER = UrlParamsReplace('/email-purchase-order');

export const CREATE_FORM_PDF = UrlParamsReplace('/create-form-pdf');

// Analyse Files
export const ANALYSE_FILES = UrlParamsReplace('/document-processing');
export const ANALYSE_FILES_PROGRESS = (name) =>
  UrlParamsReplace('/document-processing-progress?name=:name', { name });
export const ANALYSE_SINGLE_FILE = UrlParamsReplace(
  '/single-document-processing'
);

// Export Files
export const EXPORT_FILES = UrlParamsReplace('/export-files');
export const EXPORT_STATUS_PROGRESS = (exportStatusId) =>
  UrlParamsReplace('/export-progress/:exportStatusId', { exportStatusId });
export const GENERATE_JSON_FOR_CSV = (fileId) =>
  UrlParamsReplace('/generate-json/:fileId', { fileId });

//Company Logo
export const GENERATE_COMPANY_LOGO_URL = (email) =>
  UrlParamsReplace('/generate-company-logo-url/:email', {
    email,
  });
export const GET_COMPANY_LOGO_URL = (fileUrl) =>
  UrlParamsReplace('/get-company-logo-url?fileUrl=:fileUrl', {
    fileUrl,
  });
export const UPDATE_COMPANY_LOGO = UrlParamsReplace('/update-company-logo-api');

// Forms
export const CREATE_PURCHASE_ORDER = UrlParamsReplace('/form/purchase-order');
export const CREATE_RECEIVING_SLIP = UrlParamsReplace('/form/receiving-slip');

export const UPDATE_PURCHASE_ORDER_ITEMS = UrlParamsReplace(
  '/form/update-purchase-order-items'
);

export const UPDATE_PURCHASE_ORDER_FILE = UrlParamsReplace(
  '/form/purchase-order/update-file'
);
export const MAIL_UPDATED_PURCHASE_ORDER_FILE = UrlParamsReplace(
  '/form/purchase-order/mail-updated-file'
);

export const GET_PO_DETAILS_BY_FILE_ID = (fileId) =>
  UrlParamsReplace('/purchaseOrder/:fileId', { fileId });

export const GET_PO_DETAILS_BY_SUPPLIER_ID = (supplierId) =>
  UrlParamsReplace('/purchaseOrder/inventory/:supplierId', { supplierId });

export const GET_RECEIVING_SLIP_DETAILS_BY_PO_ID = (poId) =>
  UrlParamsReplace('/receivingSlip/:poId', { poId });

export const GET_PO_DETAILS_BY_PO_NUMBERS = (poNumbers) =>
  UrlParamsReplace('/purchaseOrder/invoiceMatch/:poNumbers', { poNumbers });

export const GET_MAX_PO_NUMBER = UrlParamsReplace(
  '/purchaseOrder/getMaxNumber'
);
export const GET_MAX_RECEIVING_SLIP = UrlParamsReplace(
  '/purchaseOrder/getMaxReceivingSlip'
);
export const GET_MAX_RETURN_ORDER_NUMBER = UrlParamsReplace(
  '/purchaseOrder/getMaxReturnOrderNumber'
);
export const EDIT_PO_DETAILS = (poId) =>
  UrlParamsReplace('/purchaseOrder/:poId', { poId });

export const GET_USER_PURCHASE_ORDERS = (projectId) =>
  UrlParamsReplace('/purchaseOrder/project/:projectId', { projectId });

export const GET_INVOICE_RECEIVING_SLIP_MATCHING = UrlParamsReplace(
  '/purchaseOrder/invoiceReceivingSlipMatching'
);
export const GET_INVOICE_COUNTS = UrlParamsReplace('/invoiceDashboard/counts');
export const GET_MARKETING_DASHBOARD = (id) =>
  UrlParamsReplace('/dashboard/marketing/:id', { id });

export const SEARCH_CAMPAIGN_MARKETING_DASHBOARD = (id, search) =>
  UrlParamsReplace('/dashboard/marketing/campaign-search/:id/:search', {
    id,
    search,
  });

export const GET_CAMPAIGN_CALENDAR = UrlParamsReplace(
  '/auto-campaign-builders/calendar'
);

// Customer segments (Chatwoot contact labels)
export const GET_CHATWOOT_LABELS = UrlParamsReplace('/chatwoot/labels');

// Campaign Types
export const GET_CAMPAIGN_TYPES = UrlParamsReplace('/campaign-types');
export const UPDATE_CAMPAIGN_TYPE_BUSINESS_SETTINGS = (campaignTypeId) =>
  UrlParamsReplace('/campaign-types/:campaignTypeId/business-settings', { campaignTypeId });
export const SEARCH_ORDER_DASHBOARD = (id, search) =>
  UrlParamsReplace(`/order-transactions/search/${id}?search=${search}`);
export const UPDATE_ORDER_STATUS_DASHBOARD = (id) =>
  UrlParamsReplace('/dashboard/order/:id', {
    id,
  });
// export const GET_ORDER_DASHBOARD = (id) =>
//   UrlParamsReplace('/order/transactions/:id', { id });
export const GET_ORDER_DASHBOARD = (
  id,
  page = 1,
  limit = 10,
  typeOfFetch = 'all',
  startDate,
  endDate
) => {
  let url = `/order-transactions/${id}?page=${page}&limit=${limit}&typeOfFetch=${typeOfFetch}`;
  if (startDate && endDate) {
    url += `&startDate=${startDate}&endDate=${endDate}`;
  }
  return UrlParamsReplace(url);
};
export const GET_ABANDONED_ORDERS = (
  id,
  page = 1,
  limit = 10,
  startDate,
  endDate
) =>
  UrlParamsReplace(
    `/abandoned-orders/${id}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
  );

export const GET_CANCELLED_ORDERS = (
  id,
  page = 1,
  limit = 10,
  startDate,
  endDate
) =>
  UrlParamsReplace(
    `/cancelled-orders/${id}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
  );


export const GET_ORDER_DETAIL = (id, orderId) =>
  UrlParamsReplace(`/order-detail/${id}/${orderId}`);
export const FETCH_ORDER_ADDRESS = (orderTransactionId) =>
  UrlParamsReplace(`/fetch-order-address/${orderTransactionId}`);
export const GET_ORDER_STATS_DASHBOARD = (id) =>
  UrlParamsReplace('/order/dashboard/:id', { id });
export const CONFIRM_OUTSTATION_PACK_OUT = (orderId) =>
  UrlParamsReplace('/orders/:orderId/outstation/pack-out', { orderId });
export const CREATE_PURCHASE_ORDER_API = UrlParamsReplace(
  '/form/create-purchase-order-api'
);
export const SEND_PUSH_SMS = (id, recipientPhoneNumber) =>
  UrlParamsReplace(
    '/dashboard/order/send-push-sms-message/:id/:recipientPhoneNumber',
    {
      id,
      recipientPhoneNumber,
    }
  );

export const CREATE_RECEIVING_SLIP_API = UrlParamsReplace(
  '/form/create-receiving-slip-api'
);

//Customer DB Credentials
export const GET_CUSTOMER_DB_CREDENTIALS_BY_USER_ID = UrlParamsReplace(
  '/customerDBCredentials/userId'
);

//Payments
export const CREATE_PAYMENT = UrlParamsReplace('/payments');

export const GET_PAYMENTS_STATUS = (projectId, searchText, page, status) =>
  UrlParamsReplace(
    '/payments-status-details?searchText=:searchText&projectId=:projectId&page=:page&status=:status',
    {
      searchText,
      projectId,
      page,
      status,
    }
  );

export const GET_PAYMENT_DETAILS_BY_PO_ID = (poId) =>
  UrlParamsReplace('/payments/purchaseOrder/:poId', { poId });

export const GET_PAYMENT_DETAILS_BY_INVOICE_ID = (invoiceId) =>
  UrlParamsReplace('/payments/invoice/:invoiceId', { invoiceId });

export const EDIT_PAYMENT_DETAILS = (paymentId) =>
  UrlParamsReplace('/payments/:paymentId', { paymentId });

// Product Template
export const CREATE_PRODUCT_TEMPLATES = UrlParamsReplace(
  '/product_templates/create_product_template'
);
export const GET_ALL_PRODUCT_TEMPLATES = (businessAccountId, page) =>
  UrlParamsReplace('/product_templates/:businessAccountId/:page', {
    businessAccountId,
    page,
  });
export const GET_PRODUCT_TEMPLATE = (
  id,
  status,
  whatsappMainMenu,
  businessAccountId
) =>
  UrlParamsReplace(
    '/product_template?id=:id&status=:status&whatsappMainMenu=:whatsappMainMenu&businessAccountId=:businessAccountId',
    {
      id,
      status,
      whatsappMainMenu,
      businessAccountId,
    }
  );
export const GET_BUSINESS_ACTIVE_PRODUCT_TEMPLATE = (
  id,
  status,
  whatsappMainMenu,
  businessAccountId
) =>
  UrlParamsReplace(
    '/business_active_product_template?id=:id&status=:status&whatsappMainMenu=:whatsappMainMenu&businessAccountId=:businessAccountId',
    {
      id,
      status,
      whatsappMainMenu,
      businessAccountId,
    }
  );
export const UPDATE_PRODUCT_TEMPLATE = UrlParamsReplace(
  '/update-product-template'
);

export const UPDATE_PRODUCT_TEMPLATE_STATUS = (productTemplateId, status) =>
  UrlParamsReplace('/productTemplate/:productTemplateId/:status', {
    productTemplateId,
    status,
  });

export const UPDATE_PRODUCT_TEMPLATE_INVENTORY_SYNC_STATUS = (
  productTemplateId,
  status
) =>
  UrlParamsReplace('/productTemplateInventorySync/:productTemplateId/:status', {
    productTemplateId,
    status,
  });

//Flyer
export const CREATE_UPDATE_FLYER = UrlParamsReplace('/flyer/flyer-items');
export const CREATE_FLYER = UrlParamsReplace('/flyer/flyer-items');
export const UPDATE_FLYER = UrlParamsReplace('/flyer/flyer-items-update');

export const GET_ALL_FLYERS = (businessAccountId) =>
  UrlParamsReplace('/flyers/:businessAccountId', { businessAccountId });

export const GENERATE_PRESIGNED_META_URL = (folderName, storeName, fileName) =>
  UrlParamsReplace(
    '/generate-presigned-meta-url/:folderName/:storeName/:fileName',
    {
      folderName,
      storeName,
      fileName,
    }
  );

export const UPDATE_FLYER_STATUS = (flyerId, status) =>
  UrlParamsReplace('/flyer/:flyerId/:status', {
    flyerId,
    status,
  });

export const GET_ALL_CHANNELS = (businessAccountId) =>
  UrlParamsReplace('/channel_list', {
    businessAccountId,
  });
// Channel Whatsapp
export const CREATE_WHATSAPP_CHANNEL = UrlParamsReplace(
  '/channel-whatsapp/create-channel-whatsapp'
);
export const TRIGGER_WHATSAPP_ONBOARDING = UrlParamsReplace(
  '/channel-whatsapp/trigger-whatsapp-onboarding'
);
export const GET_WHATSAPP_ONBOARDING_STATUS = UrlParamsReplace(
  '/channel-whatsapp/onboarding-status'
);
export const GET_WHATSAPP_ONBOARDING_MPM_ALIASES = (userId) =>
  UrlParamsReplace(
    '/channel-whatsapp/default-onboarding-mpm-aliases-template/:userId',
    { userId }
  );
export const WHATSAPP_SMB_SYNC = UrlParamsReplace('/channel-whatsapp/smb-sync');

export const UPDATE_CATALOGUE = UrlParamsReplace(
  '/channel-whatsapp/update-catalogue'
);

export const CREATE_MPM_TEMPLATE = UrlParamsReplace(
  '/channel-whatsapp/create-mpm-template'
);

export const GET_CATALOGUE_DETAILS = (businessAccountId) =>
  UrlParamsReplace('/channel-whatsapp/catalogue/:businessAccountId', {
    businessAccountId,
  });

// Afto Chat Account
export const GET_CHAT_USER_SSO_LINK = (userId) =>
  UrlParamsReplace(`/chatAccount/User/chatUserSSOLink?userId=${userId}`);

// POS List
export const GET_ALL_POS_LIST = UrlParamsReplace('/pos_list');

export const UPDATE_BUSINESS_POS = UrlParamsReplace('/assign-pos-to-business');

//Industry
export const GET_ALL_INDUSTRY_LIST = UrlParamsReplace('/industries');
export const GET_SERVICES_BY_INDUSTRY = (industryId) =>
  UrlParamsReplace('/services/industry/:industryId', { industryId });

// library
export const GET_ALL_LIBRARY_TEMPLATES = (id, page) =>
  UrlParamsReplace('/library/templates/:id/:page', {
    id,
    page,
  });
export const ADD_LIBRARY_TEMPLATES = UrlParamsReplace('/library/add-template');
export const MAKE_DEFAULT_LIBRARY_TEMPLATE = UrlParamsReplace(
  '/library/make-default-library-template'
);

export const FORK_LIBRARY_TEMPLATES = UrlParamsReplace('/library/fork');
export const GET_FORK_COUNT_LIBRARY_TEMPLATES = (templateId) =>
  UrlParamsReplace('/library/get-template-count/:templateId', {
    templateId,
  });

export const GET_LIBRARY_TEMPLATES = (templateId) =>
  UrlParamsReplace('/library/template/:templateId', {
    templateId,
  });

// Stripe Connect
export const GET_ONBOARDING_URL = (userId) =>
  UrlParamsReplace('/connect/account/:userId', {
    userId,
  });
export const GET_ONBOARDING_ENABLE_CHECK = (userId) =>
  UrlParamsReplace('/connect/onboarding-enable-check/:userId', {
    userId,
  });

export const UPDATE_BUSINESS_BY_ID = (id) =>
  UrlParamsReplace('/update-business-accounts/:id', { id });
export const UPLOAD_TO_AZURE_ETL = UrlParamsReplace(
  '/files/upload-to-azure-etl'
);

// Menu Docs
export const GET_MENU_DOCS = UrlParamsReplace('/menu-docs');

export const FIND_OPTIMAL_ROUTE = UrlParamsReplace('/find-route-all');

export const SEND_CUSTOM_PUSH_SMS = UrlParamsReplace(
  '/dashboard/order/send-custom-push-sms'
);

// WhatsApp Templates
export const GET_WHATSAPP_TEMPLATE_LIST = UrlParamsReplace(
  '/channel-whatsapp/templates/list'
);
export const GET_WHATSAPP_TEMPLATE_BY_ID = (templateId) =>
  UrlParamsReplace('/channel-whatsapp/templates/:templateId', { templateId });
export const CREATE_WHATSAPP_TEMPLATE = UrlParamsReplace(
  '/channel-whatsapp/templates'
);
export const UPDATE_WHATSAPP_TEMPLATE = (templateId) =>
  UrlParamsReplace('/channel-whatsapp/templates/:templateId', { templateId });
export const TOGGLE_WHATSAPP_TEMPLATE_STATUS = (templateId) =>
  UrlParamsReplace('/channel-whatsapp/templates/:templateId/status', {
    templateId,
  });
export const DELETE_WHATSAPP_TEMPLATE = (templateId) =>
  UrlParamsReplace('/channel-whatsapp/templates/:templateId', { templateId });
export const REORDER_WHATSAPP_TEMPLATE = UrlParamsReplace(
  '/channel-whatsapp/templates/reorder'
);
export const UPLOAD_TEMPLATE_IMAGE = UrlParamsReplace('/upload-template-image');

// WhatsApp Products
export const SEARCH_WHATSAPP_PRODUCTS = UrlParamsReplace(
  '/channel-whatsapp/products'
);
export const CREATE_WHATSAPP_PRODUCT = UrlParamsReplace(
  '/channel-whatsapp/products'
);
export const UPDATE_WHATSAPP_PRODUCT = (productId) =>
  UrlParamsReplace('/channel-whatsapp/products/:productId', { productId });
export const REMOVE_PRODUCT_SALE = UrlParamsReplace('/products/remove-sale');

// WhatsApp Categories & Brands
export const GET_WHATSAPP_CATEGORIES = UrlParamsReplace(
  '/channel-whatsapp/categories'
);
export const GET_WHATSAPP_SUBCATEGORIES = (categoryId) =>
  UrlParamsReplace('/channel-whatsapp/categories/:categoryId/subcategories', {
    categoryId,
  });
export const GET_WHATSAPP_BRANDS = UrlParamsReplace('/channel-whatsapp/brands');
export const GET_WHATSAPP_TAX_SLABS = UrlParamsReplace(
  '/channel-whatsapp/tax-slabs'
);

// New Product Creation APIs
export const CREATE_PRODUCT = UrlParamsReplace('/products/create');
export const GET_PRODUCTS = UrlParamsReplace('/products');
export const GET_PRODUCTS_BULK = UrlParamsReplace('/products/bulk-Get');
export const UPDATE_PRODUCT_DETAILS = UrlParamsReplace('/products/details');
export const ESTIMATE_PRODUCT_SHIPPING = UrlParamsReplace('/products/shipping-estimates');
export const GET_BRANDS_DROPDOWN = UrlParamsReplace('/brands/dropdown');
export const GET_CATEGORIES_DROPDOWN = UrlParamsReplace('/categories/dropdown');
export const GET_SUBCATEGORIES_DROPDOWN = (categoryId) =>
  UrlParamsReplace('/categories/:categoryId/subcategories/dropdown', {
    categoryId,
  });
export const GET_ALL_SUBCATEGORIES = UrlParamsReplace('/categories/subcategories');
export const GET_TAX_SLABS_DROPDOWN = UrlParamsReplace('/tax-slabs/dropdown');

// Category & sub-category management (Inventory)
export const GET_CATEGORIES = UrlParamsReplace('/categories');
export const GET_CATEGORY_SUBCATEGORIES = (categoryId) =>
  UrlParamsReplace('/categories/:categoryId/subcategories', { categoryId });
export const CREATE_CATEGORY = UrlParamsReplace('/categories/');
export const CREATE_SUBCATEGORY = UrlParamsReplace('/subcategories/');
export const UPDATE_CATEGORY = (categoryId) =>
  UrlParamsReplace('/categories/:categoryId', { categoryId });
export const UPDATE_SUBCATEGORY = (subcategoryId) =>
  UrlParamsReplace('/subcategories/:subcategoryId', { subcategoryId });

// Subscription plans
export const GET_SUBSCRIPTION_PLANS = UrlParamsReplace('/subscription-plans');
export const CREATE_SUBSCRIPTION_PLAN = UrlParamsReplace('/subscription-plans');
export const GET_SUBSCRIPTION_PLAN_BY_ID = (planId) => UrlParamsReplace('/subscription-plans/:planId', { planId });
export const UPDATE_SUBSCRIPTION_PLAN = (planId) => UrlParamsReplace('/subscription-plans/:planId', { planId });
export const DELETE_SUBSCRIPTION_PLAN = (planId) => UrlParamsReplace('/subscription-plans/:planId', { planId });

// Subscription menu templates — reusable menus attached to one or more subscription plans
export const GET_SUBSCRIPTION_MENU_TEMPLATES = UrlParamsReplace('/subscription-menu-templates');
export const CREATE_SUBSCRIPTION_MENU_TEMPLATE = UrlParamsReplace('/subscription-menu-templates');
// PUT, not PATCH: afto_api's route.js supports get/post/put/delete only.
export const RENAME_SUBSCRIPTION_MENU_TEMPLATE = (templateId) =>
  UrlParamsReplace('/subscription-menu-templates/:templateId', { templateId });
export const REPLACE_SUBSCRIPTION_MENU_TEMPLATE_ITEMS = (templateId) =>
  UrlParamsReplace('/subscription-menu-templates/:templateId/items', { templateId });

// The optional per-week menu override — when a week has rows they replace the plans' standing
// menus for that week only. One menu per store per week, keyed on the Monday.
export const GET_SUBSCRIPTION_WEEKLY_MENU = (weekStartDate) =>
  `${UrlParamsReplace('/subscription-weekly-menus')}?weekStartDate=${weekStartDate}`;
export const UPDATE_SUBSCRIPTION_WEEKLY_MENU = (weekStartDate) =>
  `${UrlParamsReplace('/subscription-weekly-menus')}?weekStartDate=${weekStartDate}`;

// Subscribers — the merchant's view of the same /subscriptions resource shoppers manage.
export const GET_BUSINESS_SUBSCRIPTIONS = UrlParamsReplace('/subscriptions');
export const GET_BUSINESS_SUBSCRIPTION = (subscriptionId) =>
  UrlParamsReplace('/subscriptions/:subscriptionId', { subscriptionId });
export const ACKNOWLEDGE_SUBSCRIPTION_DISPUTE = (subscriptionId, cycleId) =>
  UrlParamsReplace('/subscriptions/:subscriptionId/cycles/:cycleId/acknowledge-dispute', { subscriptionId, cycleId });

// The delivery planner — every box due in a window, paid or not, with per-day totals.
export const GET_SUBSCRIPTION_CYCLES = UrlParamsReplace('/subscription-cycles');

// Delivery runs — one kitchen batch per delivery date, with its three printable documents.
export const GET_SUBSCRIPTION_DELIVERY_BATCHES = UrlParamsReplace('/subscription-delivery-batches');
export const GET_SUBSCRIPTION_DELIVERY_BATCH = (batchId) =>
  UrlParamsReplace('/subscription-delivery-batches/:batchId', { batchId });
export const REGENERATE_SUBSCRIPTION_DELIVERY_BATCH = (batchId) =>
  UrlParamsReplace('/subscription-delivery-batches/:batchId/regenerate', { batchId });
export const RESEND_SUBSCRIPTION_DELIVERY_BATCH_EMAIL = (batchId) =>
  UrlParamsReplace('/subscription-delivery-batches/:batchId/resend-email', { batchId });

// Delivery
export const GET_DELIVERY_OPTIONS = UrlParamsReplace('/delivery-options');
export const UPDATE_DELIVERY_CONFIG = UrlParamsReplace('/delivery-config');
export const CREATE_SELF_DELIVERY_RANGE = UrlParamsReplace(
  '/self-delivery-range'
);
export const UPDATE_SELF_DELIVERY_RANGE = (rangeId) =>
  UrlParamsReplace('/self-delivery-range/:rangeId', { rangeId });
export const DELETE_SELF_DELIVERY_RANGE = (rangeId) =>
  UrlParamsReplace('/self-delivery-range/:rangeId', { rangeId });
export const GET_ALL_DELIVERY_CONFIGS = UrlParamsReplace('/delivery-configs');
export const GET_DELIVERY_WEEKLY_SCHEDULE = UrlParamsReplace('/delivery-weekly-schedule');
export const UPDATE_DELIVERY_WEEKLY_SCHEDULE = UrlParamsReplace('/delivery-weekly-schedule');

// Packaging boxes (outstation shipping)
export const GET_PACKAGING_BOXES = UrlParamsReplace('/packaging-boxes');
export const CREATE_PACKAGING_BOX = UrlParamsReplace('/packaging-boxes');
export const UPDATE_PACKAGING_BOX = UrlParamsReplace('/packaging-boxes');
export const DEACTIVATE_PACKAGING_BOX = (boxId) =>
  UrlParamsReplace('/packaging-boxes/:boxId', { boxId });
export const VERIFY_MAGIC_LINK = UrlParamsReplace('/admin/magic-link/verify');

// Business Services & Blogs
export const GET_BUSINESS_SERVICES = (businessId) =>
  UrlParamsReplace('/businesses/:businessId/services', { businessId });
export const GET_BUSINESS_BLOGS = (businessId) =>
  UrlParamsReplace('/llm-content?businessId=:businessId&status=published', {
    businessId,
  });

// LLM Content / Patient Search
// LLM Content / Patient Search - Removed unused APIs

// Orders
export const GET_ORDER_POSSIBLE_STATUSES = (orderId) =>
  UrlParamsReplace('/orders/:orderId/possible-statuses', { orderId });

export const UPDATE_ORDER_STATUS = (orderId) =>
  UrlParamsReplace('/orders/:orderId/status', { orderId });

export const GET_ORDER_REFUND_PREVIEW = (orderId) =>
  UrlParamsReplace('/orders/:orderId/refund-preview', { orderId });

// Loyalty
export const GET_LOYALTY_SETTINGS = UrlParamsReplace('/loyalty/settings');
export const CREATE_LOYALTY_SETTINGS = UrlParamsReplace('/loyalty/settings');
export const UPDATE_LOYALTY_SETTINGS = UrlParamsReplace('/loyalty/settings');

export const GET_LOYALTY_TIERS = UrlParamsReplace('/loyalty/tiers');
export const CREATE_LOYALTY_TIER = UrlParamsReplace('/loyalty/tiers');
export const UPDATE_LOYALTY_TIER = (tierId) =>
  UrlParamsReplace('/loyalty/tiers/:tierId', { tierId });

export const GET_LOYALTY_RULES = (isActive) =>
  UrlParamsReplace(`/loyalty/rules${isActive !== undefined ? `?isActive=${isActive}` : ''}`);
export const CREATE_LOYALTY_RULE = UrlParamsReplace('/loyalty/rules');
export const UPDATE_LOYALTY_RULE = (ruleId) =>
  UrlParamsReplace('/loyalty/rules/:ruleId', { ruleId });

export const GET_LOYALTY_STATS = UrlParamsReplace('/loyalty/stats');
export const GET_LOYALTY_TOP_CUSTOMERS = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return UrlParamsReplace(`/loyalty/top-customers?${queryString}`);
};
export const GET_LOYALTY_RECENT_TRANSACTIONS = (params) => {
  const qs = new URLSearchParams();
  if (params.limit) qs.set('limit', params.limit);
  if (params.cursor) qs.set('cursor', params.cursor);
  if (params.cursorId) qs.set('cursorId', params.cursorId);
  return UrlParamsReplace(`/loyalty/recent-transactions?${qs.toString()}`);
};

export const SEARCH_LOYALTY_CUSTOMERS = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return UrlParamsReplace(`/loyalty/customers/search?${queryString}`);
};

export const LOYALTY_SEARCH_BY_MOBILE = (mobile) =>
  UrlParamsReplace(`/loyalty/customers/search?search=${encodeURIComponent(mobile)}&searchType=mobile`);

export const GET_CUSTOMER_LOYALTY_DETAIL = (customerId) =>
  UrlParamsReplace('/loyalty/customers/:customerId/detail', { customerId });

export const ADJUST_CUSTOMER_LOYALTY_POINTS = (customerId) =>
  UrlParamsReplace('/loyalty/customers/:customerId/adjust', { customerId });

export const PREVIEW_CUSTOMER_LOYALTY_POINTS = (customerId) =>
  UrlParamsReplace('/loyalty/customers/:customerId/points-preview', { customerId });

// Website Pages
export const GET_BUSINESS_WEBSITE_DOMAIN = (businessAccountId) =>
  UrlParamsReplace('/website-pages/business/:businessAccountId/domain', { businessAccountId });

// Loyalty Redemption Offers
export const GET_LOYALTY_OFFERS = (isActive) =>
  UrlParamsReplace(`/loyalty/offers${isActive !== undefined ? `?isActive=${isActive}` : ''}`);
export const CREATE_LOYALTY_OFFER = UrlParamsReplace('/loyalty/offers');
export const UPDATE_LOYALTY_OFFER = (offerId) =>
  UrlParamsReplace('/loyalty/offers/:offerId', { offerId });
export const DELETE_LOYALTY_OFFER = (offerId) =>
  UrlParamsReplace('/loyalty/offers/:offerId', { offerId });
export const REDEEM_LOYALTY_OFFERS_BATCH = (customerId) =>
  UrlParamsReplace('/loyalty/customers/:customerId/redeem-offers', { customerId });

// Customer creation (used by loyalty lookup enrollment flow)
export const CREATE_CUSTOMER_URL = UrlParamsReplace('/customer/create');

// RBAC — Role Permissions
export const GET_ROLE_PERMISSIONS = UrlParamsReplace('/role-permissions');
export const UPDATE_ROLE_PERMISSIONS = UrlParamsReplace('/role-permissions');

// Multi-Store
export const CREATE_CHILD_STORE = UrlParamsReplace('/business-accounts/child-store');
export const GET_CHILD_STORES = UrlParamsReplace('/business-accounts/child-stores');
export const SEND_CHILD_STORE_INVITE = UrlParamsReplace('/business-accounts/child-store/invite');
export const GET_STORE_TOKEN = UrlParamsReplace('/business-accounts/store-token');
export const REFRESH_USER_TOKEN = UrlParamsReplace('/user/refresh-token');
export const TRIGGER_CORE_ONBOARDING = UrlParamsReplace('/onboarding/trigger-core-setup');
export const GET_CORE_SETUP_STATUS = (runId) => UrlParamsReplace('/onboarding/core-setup-status?runId=:runId', { runId });
export const CREATE_SMS_INBOX = UrlParamsReplace('/onboarding/chatwoot/create-sms-inbox');
export const CREATE_STAFF_USER = UrlParamsReplace('/user/create-staff');
export const GET_BUSINESS_USERS = UrlParamsReplace('/business-accounts/users');
export const GET_ALL_BUSINESS_ACCOUNTS_ADMIN = UrlParamsReplace('/admin/business-accounts');
export const GET_PLATFORM_VIEW_TOKEN = UrlParamsReplace('/admin/business-accounts/view-token');
export const ADMIN_ORDER_REPORTS = (businessAccountId) =>
  UrlParamsReplace('/admin/business-accounts/:businessAccountId/order-reports', { businessAccountId });

// Business Account JSON Fields
export const GET_BUSINESS_ACCOUNT_PREFERENCES = UrlParamsReplace('/business-accounts/preferences');
export const GET_BUSINESS_ACCOUNT_METADATA = UrlParamsReplace('/business-accounts/metadata');
export const UPDATE_BUSINESS_ACCOUNT_PREFERENCES = UrlParamsReplace('/business-accounts/preferences');
export const UPDATE_BUSINESS_ACCOUNT_METADATA = UrlParamsReplace('/business-accounts/metadata');

// Business Configurations
export const GET_AFTER_STORE_HOURS = UrlParamsReplace('/business-accounts/after-store-hours');
export const UPDATE_AFTER_STORE_HOURS = UrlParamsReplace('/business-accounts/after-store-hours');
export const GET_BUSINESS_CONFIGURATIONS = UrlParamsReplace('/business-accounts/configurations');
export const SET_BUSINESS_CONFIGURATION = UrlParamsReplace('/business-accounts/configurations');

// Business FAQ
export const FAQS = UrlParamsReplace('/faqs');
export const FAQ_SEARCH = UrlParamsReplace('/faqs/search');
export const FAQ_BY_ID = (faqId) => UrlParamsReplace('/faqs/:faqId', { faqId: encodeURIComponent(faqId) });
export const FAQS_ORDER = UrlParamsReplace('/faqs-order');
export const FAQ_SECTIONS = UrlParamsReplace('/faq-sections');
export const FAQ_SECTION_BY_KEY = (sectionKey) => UrlParamsReplace('/faq-sections/:sectionKey', { sectionKey });
export const FAQ_SECTIONS_ORDER = UrlParamsReplace('/faq-sections-order');

// Voice assistant: the phone numbers it answers, and the calls it took
export const VOICE_NUMBERS = UrlParamsReplace('/voice-numbers');
export const VOICE_NUMBER_BY_ID = (voiceNumberId) => UrlParamsReplace('/voice-numbers/:voiceNumberId', { voiceNumberId });
export const VOICE_CALLS = UrlParamsReplace('/voice-calls');
export const VOICE_CALL_BY_ID = (callId) => UrlParamsReplace('/voice-calls/:callId', { callId: encodeURIComponent(callId) });
export const GET_RETURN_SETTINGS = UrlParamsReplace('/return-settings');
export const UPDATE_RETURN_SETTINGS = UrlParamsReplace('/return-settings');
export const GET_CUSTOMER_WALLET = (customerId) =>
  UrlParamsReplace('/customers/:customerId/wallet', { customerId });
export const GET_CUSTOMER_WALLET_TRANSACTIONS = (customerId) =>
  UrlParamsReplace('/customers/:customerId/wallet/transactions', { customerId });
export const CREATE_WALLET_CORRECTION = (customerId) =>
  UrlParamsReplace('/customers/:customerId/wallet/corrections', { customerId });
export const SEARCH_WALLET_CUSTOMERS = (mobile) =>
  UrlParamsReplace(`/wallet/customers/search?search=${encodeURIComponent(mobile)}`);
// The same route with no search lists the store's wallets.
export const LIST_CUSTOMER_WALLETS = UrlParamsReplace('/wallet/customers/search');
export const GET_GIFT_CARDS = UrlParamsReplace('/gift-cards');
export const GET_GIFT_CARD = (giftCardId) => UrlParamsReplace('/gift-cards/:giftCardId', { giftCardId });
export const UPDATE_GIFT_CARD = (giftCardId) => GET_GIFT_CARD(giftCardId);
export const RESEND_GIFT_CARD =(giftCardId) => UrlParamsReplace('/gift-cards/:giftCardId/resend', { giftCardId });

export const GET_RETURNS = UrlParamsReplace('/returns');
export const GET_RETURN_BY_ID = (id) => UrlParamsReplace('/returns/:id', { id });
export const DECIDE_RETURN_ITEM = (id) => UrlParamsReplace('/return-items/:id/decision', { id });
export const INSPECT_RETURN_ITEM = (id) => UrlParamsReplace('/return-items/:id/inspect', { id });
export const SEND_RETURN_LABEL = (id) => UrlParamsReplace('/returns/:id/label', { id });
export const GET_RETURN_LABEL_QUOTE = (id) => UrlParamsReplace('/returns/:id/label/quote', { id });
export const CHECK_RETURN_LABEL = (id) => UrlParamsReplace('/returns/:id/label/check', { id });
export const GET_BUSINESS_CANVA_TEMPLATES = UrlParamsReplace('/business-accounts/canva-templates');
export const SAVE_BUSINESS_CANVA_TEMPLATE = UrlParamsReplace('/business-accounts/canva-templates');
export const GET_CANVA_BRAND_TEMPLATE = (id) => UrlParamsReplace('/canva/brand-templates/:id', { id });
export const GET_WEBSITE_SETTINGS = UrlParamsReplace('/website-settings');

// Coupons
export const GET_COUPONS = (params) => {
  const qs = new URLSearchParams();
  if (params?.isActive !== undefined) qs.set('isActive', params.isActive);
  if (params?.couponType) qs.set('couponType', params.couponType);
  if (params?.search) qs.set('search', params.search);
  if (params?.limit) qs.set('limit', params.limit);
  if (params?.offset) qs.set('offset', params.offset);
  const q = qs.toString();
  return UrlParamsReplace(`/coupons${q ? `?${q}` : ''}`);
};
export const CREATE_COUPON = UrlParamsReplace('/coupons');
export const GET_COUPON_BY_ID = (couponId) =>
  UrlParamsReplace('/coupons/:couponId', { couponId });
export const UPDATE_COUPON = (couponId) =>
  UrlParamsReplace('/coupons/:couponId', { couponId });
export const DELETE_COUPON = (couponId) =>
  UrlParamsReplace('/coupons/:couponId', { couponId });
export const DUPLICATE_COUPON = (couponId) =>
  UrlParamsReplace('/coupons/:couponId/duplicate', { couponId });
export const GET_COUPON_ANALYTICS = (couponId) =>
  UrlParamsReplace('/coupons/:couponId/analytics', { couponId });
export const SEND_COUPON = (couponId) =>
  UrlParamsReplace('/coupons/:couponId/send', { couponId });

// Customer Segments
export const GET_CUSTOMER_SEGMENTS = (params) => {
  const qs = new URLSearchParams();
  if (params?.customerId) qs.set('customerId', params.customerId);
  const q = qs.toString();
  return UrlParamsReplace(`/customer-segments${q ? `?${q}` : ''}`);
};
export const ASSIGN_CUSTOMER_SEGMENT = UrlParamsReplace('/customer-segments');
export const REMOVE_CUSTOMER_SEGMENT = (segmentId) =>
  UrlParamsReplace('/customer-segments/:segmentId', { segmentId });

// Email unsubscribe (public)
export const EMAIL_UNSUBSCRIBE_URL = (token) =>
  UrlParamsReplace(`/email/unsubscribe?token=${encodeURIComponent(token)}`);

// Social channels (Facebook, and later Instagram / LinkedIn)
export const GET_SOCIAL_CHANNELS = UrlParamsReplace('/social-channels');
export const CONNECT_SOCIAL_CHANNEL = (channel) =>
  UrlParamsReplace('/social-channels/:channel/connect', { channel });
export const GET_SOCIAL_CHANNEL_ACCOUNTS = (channel) =>
  UrlParamsReplace('/social-channels/:channel/accounts', { channel });
export const UPDATE_SOCIAL_CHANNEL = (channel) =>
  UrlParamsReplace('/social-channels/:channel', { channel });
export const DISCONNECT_SOCIAL_CHANNEL = (channel) =>
  UrlParamsReplace('/social-channels/:channel', { channel });

// A driver's read-only link to one day's delivery run.
export const SHARE_DRIVER_ROUTE = UrlParamsReplace('/subscriptions/delivery-route/share');
